/**
 * RISK-DOT
 * Pastille d'un niveau de risque (risque physique sans note IDTree, niveau RPS)
 */
interface Props {
  color: string
  isSmall?: boolean //12px au lieu de 20px, a cote d'un score
}

export default function RiskDot({ color, isSmall }: Props) {
  return (
    <span
      className={`shrink-0 rounded-full ${isSmall ? "h-[12px] w-[12px]" : "h-[20px] w-[20px]"}`}
      style={{ background: `radial-gradient(circle at 35% 30%, ${color}99, ${color} 65%)` }}
    />
  )
}
